// extracted by mini-css-extract-plugin
module.exports = {"FooterCardList":"FooterCardList__2S5BO"};